module.exports = __webpack_public_path__ + "fonts/montserrat-regular.6c8807219b0ecffdf96122b80df3e62c.woff2";